import React, { Component } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
///import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Loader, Link, FormattedDateRange} from '@jutro/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { PolicyService } from 'gw-capability-policy';
import metadata from './AuditStatements.metadata.json5';
import styles from './AuditStatements.module.scss';
import messages from './AuditStatements.messages';

class AuditStatements extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string
                    })
                })
            }),
            billingData: PropTypes.shape({})
        }).isRequired,
        policyNumber: PropTypes.shape('').isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired
    };

    state = {
        auditStatements: [],
        auditStatementsSave: [],
        isLoading: true,
        docSessionID: '',
        policieValues: [],
        selectedPolicy: 'All',
        hasMultiPolicies: false,
        isbillingAuditsAvailable: true
    };

    componentDidMount() {
        this.getAuditStatementsInfo();
    }

    getAuditStatementsInfo = async () => {
        const { authHeader, policyNumber, fromAccountLanding } = this.props;
        const isBilling = _.get(fromAccountLanding, 'basePath').includes('/ri-billing');

        // Find the multi policies for a single billing account.
        let multiPolicies = [];
        if (isBilling) {
            multiPolicies = this.getMultiPolicies(fromAccountLanding);
        }

        // Using a temporary array to concatenate audits of multiple policies
        const preBuildAuditStatments = [];

        if (isBilling && multiPolicies.includes(policyNumber)) {
            this.setState({
                policieValues: this.getPolicies(multiPolicies),
                hasMultiPolicies: true
            });

            multiPolicies.forEach((policy) => {
                this.callServiceAndBuildData(policy, authHeader, preBuildAuditStatments);
            });
        } else {
            this.callServiceAndBuildData(policyNumber, authHeader, preBuildAuditStatments);
        }
    };

    getMultiPolicies = (fromAccountLanding) => {
        const billingTermsResponse = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].relatedAccountBillingSummaries_Ext'
        );

        let ownedPolicies = [];

        if (_.isEmpty(billingTermsResponse)) {
            return ownedPolicies;
        }

        ownedPolicies = billingTermsResponse.map((data) => {
            // Replace the element object with a new object.
            if (data.ownedPolicies.length > 1) {
                return {
                    ownedPolicies: data.ownedPolicies
                };
            }
        });

        const filtered = ownedPolicies.filter((data) => {
            return data != null;
        });

        if (filtered.length === 0) {
            return filtered;
        }

        const temp = filtered[0].ownedPolicies.map((data) => {
            return data.policyNumber;
        });

        const finalArray = temp.reverse();
        return finalArray;
    };

    handleFilterValueChange = (value) => {
        this.setState({ selectedPolicy: value });
        let { auditStatementsSave } = this.state;

        const filter = {
            selectedPolicy: value
        };
        const selectedPolicy = _.get(filter, 'selectedPolicy');

        if (selectedPolicy && selectedPolicy !== 'All') {
            auditStatementsSave = _.filter(auditStatementsSave, (audit) => {
                return audit.policyNumber === selectedPolicy;
            });
        }

        const auditStatements = auditStatementsSave;
        this.setState({ auditStatements });
    };

    getPolicies = (multiPolicies) => {
        const policyPicker = [{
            code: 'All',
            name: 'All'
        }];
        multiPolicies.forEach((policy) => {
            policyPicker.push({
                code: policy,
                name: policy
            },);
        });

        return policyPicker;
    };

    callServiceAndBuildData(policyNumber, authHeader, preBuildAuditStatments) {
        PolicyService.getAuditsForPolicy_Ext(policyNumber, 'All', authHeader).then(
            (getAuditResponse = {}) => {
                if (!_.isUndefined(getAuditResponse) && !_.isEmpty(getAuditResponse)) {
                    // Need to display the audits for selected policy term.
                    const currentTermAudits = _.filter(getAuditResponse, (audit) => {
                        return audit.policyNumber === policyNumber;
                    });

                    if (!_.isEmpty(currentTermAudits)) {
                        const auditStatementsDataTable = this.getAuditStatementsDataTable(currentTermAudits);
                        preBuildAuditStatments.push(...auditStatementsDataTable);

                        this.setState({
                            auditStatements: preBuildAuditStatments,
                            auditStatementsSave: preBuildAuditStatments,
                            docSessionID: currentTermAudits[0].docSessionID,
                            isLoading: false,
                            isbillingAuditsAvailable: preBuildAuditStatments.length > 0 // FB 16137
                        });
                    } else {
                        this.setState({ isbillingAuditsAvailable: false, isLoading: false });
                    }
                } else {
                    this.setState({ isbillingAuditsAvailable: false, isLoading: false });
                }
            }
        );
    }

    getAuditStatementsDataTable = (auditStatements) => {
        let arrayResult = [];
        arrayResult = auditStatements.map((data) => {
            const objData = {
                payrollForm: data.premRepInsuredCopyDocID,
                insuredName: data.insuredName,
                policyNumber: data.policyNumber,
                auditEffectiveDate: data.auditEffectiveDate,
                auditExpirationDate: data.auditExpirationDate,
                dueDate: this.getFormattedDate(data.dueDate),
                receiveDate: this.getFormattedDate(data.receiveDate),
                processedDate: this.getFormattedDate(data.processedDate),
                auditStatus: data.secondaryStatus,
                auditType: data.auditType,
                changeInPremium: data.billedAmount,
                totalCost: data.statementAmount,
                auditStatement: data.asinsuredCopyDocID
            };
            return objData;
        });

        const sortedData = _.orderBy(arrayResult, (o) => {
            return o.auditExpirationDate;
        }, ['desc']);

        return sortedData;
    };

    getCell = (items, index, property) => {
        return (
            <span title="" className={styles.riGeneralField}>
                {items[property.id]}
            </span>
        );
    };

    getFormattedCurrency = (item, index, property) => {
        const displayValue = item[property.id];
        if (displayValue === undefined) {
            return (
                <span className={styles.riCurrencyField}>-</span>
            );
        }
        return (
            <span className={styles.riCurrencyField}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={displayValue}
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        const d = date === undefined || date === '' ? '-'
            : intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
        return d;
    };

    getFormattedUSADate = (date) => {
        let d = '';
        if (date !== undefined) {
            const dt = new Date(date);
            const year = dt.getFullYear();
            const month = (1 + dt.getMonth()).toString().padStart(2, '0');
            const day = dt.getDate().toString().padStart(2, '0');
            d = `${month}/${day}/${year}`;
        }
        return d;
    };

    getIconLink = (item, index, property) => {
        if (item[property.id] === undefined) {
            return <span />;
        }

        const downloadLink = this.getDownloadLink(item[property.id]);
        return (
            <span className={styles.riIconLinkField}>
                <Link
                    icon="mi-insert_drive_file"
                    href={downloadLink}
                    className={styles.documentName}
                    target="_blank"
                />
            </span>
        );
    };

    getDownloadLink = (publicID) => {
        const { docSessionID } = this.state;
        return GatewayDocumentService.downloadDocument(publicID, docSessionID);
    };

    getAuditReportingPeriod = (rowData, rowIndex) => {
        const activePeriod = rowData;
        return (
            <span className={styles.riDataRange}>
                <FormattedDateRange
                    id={`reportPeriod_${rowIndex}`}
                    value={activePeriod}
                    startDate={new Date(activePeriod.auditEffectiveDate)}
                    endDate={new Date(activePeriod.auditExpirationDate)}
                    hideLabel
                    displayFormat="short"
                />
            </span>
        );
    };

    render() {
        const {
            auditStatements,
            isLoading,
            policieValues,
            selectedPolicy,
            hasMultiPolicies,
            isbillingAuditsAvailable
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            auditStatementsTable: {
                data: auditStatements
            },
            policySelection: {
                availableValues: policieValues,
                value: selectedPolicy,
                visible: hasMultiPolicies
            },
            auditContainer: {
                visible: isbillingAuditsAvailable
            },
            billingAuditEmptyContainer: {
                visible: !isbillingAuditsAvailable
            },
            warningMessage: {
                value: translator(messages.noAuditFound)
            }
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getIconLink: this.getIconLink,
                getFormattedCurrency: this.getFormattedCurrency,
                getFormattedUSADate: this.getFormattedUSADate,
                handleFilterValueChange: this.handleFilterValueChange,
                getAuditReportingPeriod: this.getAuditReportingPeriod,
                getMultiPolicies: this.getMultiPolicies
            },
        };

        //const auditsPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        const auditsPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        return <div className={styles.audits}>{auditsPage}</div>;
    }
}

export default withRouter(withIntl(withAuthenticationContext(AuditStatements)));
